import Page from '../page';

// swiper/bundle（全機能）ではなく使う機能だけ読み込む。CSS は style.scss に含まれている

import Swiper, { Scrollbar } from "swiper";
import { inview } from '../../lib/inview';

import { gradient } from "./gradient";
import { bars } from "./bars";
//import { dot } from "./dot";

export default class AboutManager extends Page {
	constructor() {
		super();
	}
	init() {
		//console.log("about");
		gradient(this);
		bars();
		//dot(this);

		this.scroll();
		this.resize();
		window.dispatchEvent(new Event('resize'));



		const optionNews = {
			direction: 'horizontal',
			loop: false,
			slidesPerView: 'auto',
			slidesPerGroupAuto: 'auto',
			spaceBetween: 10,
			speed: 600,
			// pagination: {
			// 	el: '.swiper-pagination',
			// 	type: 'bullets',
			// 	clickable: true,
			// },

			modules: [Scrollbar],
			scrollbar: {
				el: '.swiper-scrollbar', //要素の指定
				draggable: true,
				dragSize: 10,
			},

			breakpoints: {
				719: {
					spaceBetween: 20,
				}
			}
		}

		const swiper = new Swiper('#officeSwiper', optionNews);

		const slides = Array.from(document.getElementsByClassName("swiper-slide"));


		inview(document.getElementById('officeSwiper'), (direction) => {
			if (direction == "down") {
				let countNum = 0;

				slides.forEach((slide) => {
					setTimeout(function () {
						slide.classList.add('active');
					}, 200 * countNum);

					countNum++;
				});
			} else {
				slides.forEach((slide) => {
					slide.classList.remove('active');
				});
			}
		});

	}
	scroll() {

	}
	resize() {
		window.addEventListener('resize', function (e) {

		})
	}
}